import React from "react";
import { TextField } from '@rmwc/textfield';
import {
  DialogTitle,
  DialogContent
} from '@rmwc/dialog';

import '@material/dialog/dist/mdc.dialog.css';
import '@material/textfield/dist/mdc.textfield.css';
import '@material/floating-label/dist/mdc.floating-label.css';
import '@material/notched-outline/dist/mdc.notched-outline.css';
import '@material/line-ripple/dist/mdc.line-ripple.css';

class PaddleLength extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      distanceparameters: props.distanceparameters,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
      this.setState({
        distanceparameters: {
          ...this.state.distanceparameters,
          tipToTip: event.target.valueAsNumber,
        },
      }, () => {
        this.props.onChange(this.state.distanceparameters);
      });
  }
  render() {
    return (
      <div>
        <DialogTitle>Blade tip to blade tip distance (mm)</DialogTitle>
        <DialogContent style={{paddingTop: '15px'}}>
          <TextField
            id="tipToTip"
            type="number"
            outlined
            style={{width: '100%'}}
            label="Blade tip to blade tip distance"
            value={this.state.distanceparameters.tipToTip}
            onChange={(event) => this.handleChange(event)}/>
        </DialogContent>
      </div>
    );
  };
};

export default PaddleLength;